import React from 'react';
import { Building2 } from 'lucide-react';
import { Input } from '../ui/input';
import { useT } from '../../services/i18n';

const CheckoutBillingSection = ({ otherBilling, setOtherBilling, isPro, proInfo, addresses, billing, setBilling, billingAddressId, pickBillingAddress }) => {
  const { t } = useT();
  const field = (k) => (e) => setBilling(b => ({ ...b, [k]: e.target.value }));
  return (
    <div className="mt-6 border-t pt-4" data-testid="checkout-billing">
      <label className="flex items-center gap-2 text-sm cursor-pointer text-gray-800">
        <input type="checkbox" data-testid="checkout-other-billing" checked={otherBilling} onChange={(e) => setOtherBilling(e.target.checked)} className="rounded border-gray-300 text-orange-500" />
        <Building2 size={15} className="text-gray-500" /> {t('checkout.otherBilling')}{isPro && proInfo ? <span className="text-xs text-[#1e3a5f] font-medium ml-1">{t('checkout.invoiceFor', { company: proInfo.company_name })}{proInfo.vat_number ? ` (TVA ${proInfo.vat_number})` : ''}</span> : null}
      </label>
      {otherBilling && (
        <div className="mt-3 space-y-3" data-testid="checkout-billing-form">
          {addresses.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {addresses.map(a => (
                <button type="button" key={a.id} onClick={() => pickBillingAddress(a)} data-testid={`checkout-billing-address-${a.id}`}
                  className={`text-left text-xs border rounded-lg px-3 py-2 max-w-[240px] ${billingAddressId === a.id ? 'border-[#1e3a5f] bg-blue-50 ring-1 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`}>
                  <span className="font-semibold text-gray-900 block">{a.label || t('checkout.address')}{a.is_default_billing ? t('checkout.defaultBilling') : ''}</span>
                  <span className="text-gray-600">{a.first_name} {a.last_name} — {a.address}, {a.postal_code} {a.city}</span>
                </button>
              ))}
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Input data-testid="billing-company" placeholder={t('checkout.company')} value={billing.company} onChange={field('company')} />
            <Input data-testid="billing-vat" placeholder={t('checkout.vat')} value={billing.vat_number} onChange={field('vat_number')} />
            <Input data-testid="billing-firstName" placeholder={t('checkout.firstName')} value={billing.firstName} onChange={field('firstName')} />
            <Input data-testid="billing-lastName" placeholder={t('checkout.lastName')} value={billing.lastName} onChange={field('lastName')} />
            <div className="md:col-span-2"><Input data-testid="billing-address" placeholder={`${t('checkout.address')} *`} value={billing.address} onChange={field('address')} /></div>
            <Input data-testid="billing-postalCode" placeholder={`${t('checkout.postalCode')} *`} maxLength={5} value={billing.postalCode} onChange={field('postalCode')} />
            <Input data-testid="billing-city" placeholder={`${t('checkout.city')} *`} value={billing.city} onChange={field('city')} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutBillingSection;
